import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceUseProjectModelNotificationState = createStateReducer(
  initialState,
  {
    [events.useProjectModelSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "useProjectModel",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.useProjectModelFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "useProjectModel",
          flags: pushIf({
            ...error,
            failure: !Object.values(error).includes(true),
          }),
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceUseProjectModelNotificationState };
